import {Component, Input} from '@angular/core';
import {Config} from "../../services/Config";
import {Session} from "../../services/Session";
import {ILocGroupFile} from "../../interfaces/ILocGroupFile";

@Component({
  selector: 'account-files',
  templateUrl: './files.html',
})
export class AccountFilesCmp {
  @Input() files:ILocGroupFile[];
  public fileDownloadUrlPrefix:string = '';

  constructor(public config:Config, private session:Session) {
    this.fileDownloadUrlPrefix = this.config.apiUrl + '/file_download/';
  }

  downloadUrl(fileId:number):string {
    return this.fileDownloadUrlPrefix + fileId + '?token=' + encodeURIComponent(this.session.getToken());
  }
}
